import React, { createContext } from 'react';

/**
 * Stabilise React context identity across Vite HMR.
 *
 * When a module is re-executed during a hot update, `createContext()` would create a new context
 * object. Providers that were already mounted keep providing values on the old context object,
 * while consumers in the updated module read from the new one → `useContext()` returns the
 * default value (often `undefined`) and code may throw.
 *
 * By caching contexts on `globalThis`, every evaluation of the module reuses the same context
 * object. In production builds there is typically only one evaluation, so the cache is a no-op.
 */
export function hmrSafeContext<T>(key: string, fallback: T): React.Context<T> {
  const g = globalThis as unknown as Record<string, React.Context<T>>;
  return (g[key] ??= createContext<T>(fallback));
}
